<template>
  <div class='reportGrid'>
  <el-card>
    <h5 style="marginTop: 0px">Search</h5>
    <el-input placeholder="Search Content" @input="filter" v-model="search"></el-input>
    <div class="checkContainer">
      <h5>Programs</h5>
      <el-switch v-model="programsOn"/>
    </div>
    <el-checkbox-group v-if="programsOn" @change="filter" v-model="programFilters">
      <el-checkbox class="checkbox" v-for="program in programs" :label="program.name" :key="program.id"></el-checkbox>
    </el-checkbox-group>
    <h5>Users</h5>
    <el-select  v-model="userSelect" @change="filter" multiple filterable placeholder="Select" style="width: 100%;">
      <el-option class="userSelect"
        v-for="user in users"
        :key="user.id"
        :label="user.name"
        :value="user.name">
      </el-option>
    </el-select>
    <h5>Dates</h5>
    <div class="dateContainer">
      <div style="width: 60px">from: </div>
      <el-date-picker @change="filter" type="month" placeholder="from" v-model="date1" style="width: 100%;"></el-date-picker>
    </div>
    <div class="dateContainer">
      <div style="width: 60px">to: </div>
      <el-date-picker @change="filter" type="month" placeholder="to" v-model="date2" style="width: 100%;"></el-date-picker>
    </div>
  </el-card>
  <el-card v-loading="loading" class="page" key="hello">
    <ReportTable :tableData="filteredData" @updateReports2="updateReports2"/>
  </el-card>
  </div>
</template>

<script>
// import moment from 'moment'
import ReportTable from './ReportTable.vue'
import {auth} from '../main'
import {getReportsMixin} from './getReportsMixin'
import 'element-ui/lib/theme-chalk/index.css';

export default {
  components: {
    ReportTable
  },
  mixins: [getReportsMixin],
  name: 'dashboard',
  data () {
    return {
      loading: false,
      managerId: auth.currentUser.uid
    };
  },
  created () {
    this.fetchData()
  },
  methods: {
    updateReports2 () {
      console.log('props triggered')
      this.fetchData()
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.checkbox {
  display: block;
  margin-left: 0px;
  margin-bottom: 10px;
}
.checkContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
  .reportGrid {
    grid-column-gap: 10px;
    display: grid;
    grid-template-columns: 1fr 4fr;
  }
  .page {
    overflow: scroll;
    height: calc(100vh - 200px);
  }
</style>



// WEBPACK FOOTER //
// src/components/YourTeam.vue